import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';

const CompartmentAccordion = ({ compartment, children }) => {
  const { position } = compartment;

  const [expanded, setExpanded] = useState(true);

  const handleAccordionChange = (_, value) => {
    setExpanded(value);
  };

  return (
    <>
      <Accordion expanded={expanded} onChange={handleAccordionChange} sx={{ boxShadow: 'none' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Compartment #{position}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: 'surface.white', pt: 0 }}>
          {children}
        </AccordionDetails>
      </Accordion>
      <Divider sx={{ mx: 3 }} />
    </>
  );
};

CompartmentAccordion.propTypes = {
  children: PropTypes.node.isRequired,
  compartment: PropTypes.shape({
    position: PropTypes.number,
  }).isRequired,
};

export default CompartmentAccordion;
